// Firebase Konfiguration
// Hier kannst du zwischen Emulator und Cloud Service wechseln

// Setze USE_EMULATOR auf true, um den lokalen Emulator zu verwenden
// Setze USE_EMULATOR auf false, um die Firebase Cloud zu verwenden
export const USE_EMULATOR = false

// Emulator Ports (nur relevant wenn USE_EMULATOR = true)
export const EMULATOR_PORTS = {
  auth: 9090,
  firestore: 7070,
  functions: 5001
}
